<template lang="pug">
md-layout(md-column)
  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Users', :nav='nav')
    router-link(:to='{ name: "CreateUser" }')
      md-button.md-fab.md-fab-bottom-right.md-icon-button
        md-icon(md-iconset="fa fa-plus")
    user-table.content-table
</template>

<script>
  import UserTable from '../../shared-components/user/UserTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      Breadcrumbs,
      UserTable
    },
    data() {
      return {
        nav: [
          { 'title': "Users" }
        ]
      }
    }
  };
</script>

<style lang="scss" scoped>
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
  .content-table {
    margin: 25px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/user/UserList.vue